const CAMPOS_TELMEX = {
  numero_rec: 'REC/TT',
  numero_protocolo: 'Protocolo Operadora',
  designacao_claro: 'Designação Claro/Prime-ID',
  'designacao.designacao': 'Designação Claro/Prime-ID',
  designacao: 'Designação Claro/Prime-ID',
  acesso_lp: 'Designação Operadora',
  ctrl_provedor_id: 'Operadora',
  provedor_nome: 'Operadora',
  'provedor.nome': 'Operadora',
  identificacao_acesso_provedor: 'Identificação de Acesso Operadora',
  ctrl_workflow_id: 'Tipo de Serviço',
  workflow_nome: 'Tipo de Serviço',
}

function ehProvedorTelmex(ctrlProvedores = []) {
  return (ctrlProvedores || []).some(p => (p?.nome || '').toLowerCase().includes('telmex'))
}

function rotuloTelmex(chave, labelPadrao, isProvedorTelmex) {
  return isProvedorTelmex && CAMPOS_TELMEX[chave] ? CAMPOS_TELMEX[chave] : labelPadrao
}

function aplicarRotulosTelmex(abasDataType, isProvedorTelmex) {
  if (!isProvedorTelmex) return abasDataType

  return abasDataType.map(aba => ({
    ...aba,
    items: aba.items.map(item => ({
      ...item,
      keys: item.keys.map(k => ({ ...k, label: rotuloTelmex(k.key, k.label, isProvedorTelmex) })),
    })),
  }))
}

export {
  ehProvedorTelmex,
  rotuloTelmex,
  aplicarRotulosTelmex,
}
